import { createContext, useContext } from 'react';

/**
 * Context that carries an optional Enter-to-submit handler down from a `Form`
 * to its descendant `FieldInput` and `FieldKeyValue` components. When a
 * handler is present, `FieldInput` binds it to the `onKeyDown` event of its
 * `<input>` element, calling `e.preventDefault()` and invoking the handler on
 * Enter.
 */
const FormEnterContext = createContext<(() => void) | null>(null);

export const FormEnterProvider = FormEnterContext.Provider;

export const useFormEnterSubmit = () => useContext(FormEnterContext);
